import { generateGridAsSVG, GridDesign } from '@gelatoas/design-editor-calendar';

import { CalendarConfig, MediaGrid, MediaGridInfo } from 'editor/src/store/design/types';
import { LayoutFrame } from 'editor/src/store/editorModules/layouts/types';

import { elementUuids } from 'editor/src/util/uuids';

import createGridHash from '../design/createGridHash';

import { getCalendarEventsPerMonth } from './getCalendarEventsPerMonth';
import getGridToSizeFn from './getGridToSizeFn';

const createGridMediaElement = (
  frame: LayoutFrame,
  gridInfo: MediaGridInfo,
  gridDesign: GridDesign,
  spreadWidth: number,
  calendarConfig?: CalendarConfig,
): MediaGrid => {
  // The layout decides, also when the spread's previous grid carried the flag.
  const grid: MediaGridInfo = { ...gridInfo };
  if (frame.frameArea.type === 'grid' && frame.frameArea.fitToHeight) {
    grid.fitToHeight = true;
  } else {
    delete grid.fitToHeight;
  }

  const d2f = getGridToSizeFn(gridDesign, spreadWidth, frame.height, grid.fitToHeight);
  const { locale } = grid;
  const monthEvents = getCalendarEventsPerMonth(grid.gridDate, locale, calendarConfig);

  return {
    type: 'grid',
    group: '',
    name: 'grid',
    x: frame.x,
    y: frame.y,
    width: frame.width,
    height: frame.height,
    r: 0,
    uuid: elementUuids.generate(),
    content: generateGridAsSVG(gridDesign, grid.gridDate, locale, frame.width, frame.height, monthEvents, {
      d2f,
      firstDayOfWeek: grid.firstDayOfWeek,
      hideWeekNum: grid.hideWeekNum,
    }),
    personalizationLocked: true,
    unduplicable: true,
    grid,
    createdByLayout: true,
    layoutFrameId: frame.id,
    gridHash: createGridHash(grid, monthEvents),
  };
};

export default createGridMediaElement;
